'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var quickSelectMedian = _interopDefault(require('median-quickselect'));
var isArray = _interopDefault(require('is-any-array'));

/**
 * Computes the median of the given values
 * @param {Array<number>} input
 * @return {number}
 */
function median(input) {
  if (!isArray(input)) {
    throw new TypeError('input must be an array');
  }

  if (input.length === 0) {
    throw new TypeError('input must not be empty');
  }

  return quickSelectMedian(input.slice());
}

module.exports = median;
